module.exports = __webpack_public_path__ + "pc/img/body_basic-6.c3b47b10.png";